import { BigNumberish, ethers } from 'ethers';

export const parseUnits = (value: number | string, decimals: number) => {
  try {
    return ethers.utils.parseUnits(value.toString(), decimals);
  } catch (ex) {
    return ethers.constants.Zero;
  }
};

export const formatUnits = (value: BigNumberish, decimals: number): string => {
  return ethers.utils.formatUnits(value, decimals);
};
